import { Col, Row } from '@design-system/components/grid/grid';
import { TextInput } from '../../../promotions/view/components/TextInput';
import { wrapper, divider, alignRight } from '../pdf/form.css';
import { Typography } from '@design-system/components/typography/typography';
import { Toggle } from '@client/components/common/inputs/Toggle';
import { extrasVM } from '../Extras.page';

import { gridMaxContent } from '../components/ExtContentSlidesList.css';
import { Button } from '@design-system/components/button/button';
import { BannerImage } from '../components/BannerImage';
import { ExtContentSlidesList } from '../components/ExtContentSlidesList';
import { Tooltip } from '@design-system/components/tooltip/tooltip';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';

export const SlidesForm = () => {
  const vm = extrasVM.useValue().slidesVM;
  const { children } = vm;

  return (
    <div>
      <Col data-testid="ContentSlidesForm" gap="xl" className={wrapper}>
        <Col>
          <Row className={gridMaxContent}>
            <Col>
              <Row>
                <Typography variant="body" size="large" fontWeight="medium">
                  Slides
                </Typography>
                <SuperTooltip templateId="extras-slides" />
              </Row>
              <Typography variant="body" fontWeight="normal">
                Upload portrait images. Minimum image dimensions: 1125 x 2436px.
                Drag & drop to reorder
              </Typography>
            </Col>

            <Col>
              <div className={alignRight}>
                <Button
                  color="primary"
                  variant="text"
                  size="medium"
                  onClick={() => {
                    vm.dispatch('PrepareReupload');
                  }}
                >
                  Upload
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <ExtContentSlidesList
              onReorder={(newOrder) => vm.dispatch('ReorderSlides', newOrder)}
              slides={children}
              onRemove={(id) => vm.dispatch('RemoveSlide', id)}
            />
          </Row>
        </Col>

        <TextInput
          label="Title"
          description="This title will be shown to your users"
          {...vm.register('title')}
          required
        />

        <BannerImage
          imageUrl={vm.content.coverURL}
          onChange={(url) => vm.onChange('coverURL', url)}
        />

        <Row className={divider}>
          <Typography variant="body" size="large" fontWeight="medium">
            Downloadable
          </Typography>
          <Tooltip
            arrow
            title="Toggle this on to allow users to download content for offline use"
            variant="dark"
            tooltipProps={{
              maxWidth: 195,
            }}
          >
            <div>
              <Toggle
                value={vm.values.downloadable}
                onChange={() =>
                  vm.onChange('downloadable', !vm.values.downloadable)
                }
              />
            </div>
          </Tooltip>
        </Row>
      </Col>
    </div>
  );
};
